import {HttpRequestOptions} from "@2d-front-monorepo/core";

/**
 * Retry policy for the permit-submission POSTs (file uploads + permit creation).
 *
 * On mobile / in-app browsers a transient connection drop makes `fetch()` reject
 * with "Failed to fetch". By default, body-bearing requests are NOT retried
 * (see `HttpClient.executeRequest`: `methodHasBody(method) ? 0 : 1`), so a single
 * dropped request aborts the whole payment with no recovery.
 *
 * Only network-level throws are retried: HTTP error responses (4xx/5xx) do not
 * throw, so this never silently replays a request the server rejected on purpose.
 */
export const NETWORK_RETRY: Pick<HttpRequestOptions, "retry" | "retryDelay"> = {
	retry: 2,
	retryDelay: 1000
};
